import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { initSentry } from './services/sentry'
import { installGlobalErrorHandlers } from './services/telemetry'
import { enregistrerLeServiceWorker } from './services/serviceWorker'

// 1. Sentry doit être initialisé avant createRoot() et les gestionnaires
//    globaux pour capturer toutes les erreurs dès le démarrage.
initSentry()

// 2. Capte les erreurs hors du cycle de rendu React :
//    gestionnaires d'événements, promesses rejetées, chunks manquants.
installGlobalErrorHandlers()

// 3. Le service worker, enregistré ici plutôt que par le script injecté.
enregistrerLeServiceWorker()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
